import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { Observable } from 'rxjs'
import { PropertiesService } from './properties.service';
import { Errore, ListaErrori } from '../interfaces/error';
import { Linguaggi, Lingua, Linguaggio } from '../interfaces/language';

@Injectable({
	providedIn: 'root'
})
export class LanguagesService {

	dictionay:Map<string, string> = new Map<string, string>();
	errors:Map<string, string> = new Map<string, string>();

	constructor(private httpClient: HttpClient, private propService : PropertiesService ) {}

	getLanguage(value: string) : Observable<Lingua>{
		return this.httpClient.get<Lingua>(this.propService.getProp('apiPrefix')+`/api/Public/Servizi/Linguaggio?id=${value}`);
	}

	getErrors(value : string) : Observable<ListaErrori> {
		return this.httpClient.get<ListaErrori>(this.propService.getProp('apiPrefix')+`/api/Public/Servizi/Errori?id=${value}`);
	}

	getLanguages() : Observable<Linguaggi>{
		return this.httpClient.get<Linguaggi>(this.propService.getProp('apiPrefix')+'/api/Public/Servizi/ListaLinguaggi');
	}

	createDictionary(etichette:Linguaggio[]) : void {
		for (let i = 0; i < etichette.length; i++) {
			this.dictionay.set(etichette[i].etichetta, etichette[i].testo);
		}
	}

	createErrorDictionary(etichette : Errore[]) : void {
		for(let i = 0; i < etichette.length; i++){
			this.errors.set(etichette[i].codiceErrore, etichette[i].testo);
		}
	}

	getValue(key : string) : string {
		return this.dictionay.get(key);
	}

	getErrorValue(key : string) : string {
		return this.errors.get(""+key);
	}

	getDictionary() : Map<string, string> {
		return this.dictionay;
	}

}
